import tmhRequest from '@/config/tmhRequest'

export default {
    searchListConsumeMemberStatusInfoReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusinforeport/searchlistconsumememberstatusinforeport',
            method: 'post',
            data: data,
        })
    },
    searchMemberAnalysisReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberanalysisreport/searchmemberanalysisreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportConsumeMemberStatusInfoReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/consumememberstatusinforeport/exportconsumememberstatusinforeport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/consumememberstatusinforeport.js